<template>
  <footer class="container-fluid">
    <div class="logo-container">
      <div class="brilliant-logo">
        <img class="lazy" :src="assets.footerBrilliant" alt="Brilliant by Langham">
      </div>
      <div class="icon-content">
        <div class="brand-logos">
          <a
            v-for="brand in brandLogos"
            :key="brand.alt"
            href="#"
            target="_blank"
            @click.prevent
          >
            <img class="footer-header-icons" :src="brand.src" :alt="brand.alt">
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bottom-container">
      <div class="bottom-address-header">
        <p>BRILLIANT BY LANGHAM</p>
      </div>
      <div class="contact-infobar">
        <p><a href="mailto:enquiry@brilliantbylangham.com">enquiry@brilliantbylangham.com</a></p>
      </div>
      <div class="bottom-separator"></div>
      <div class="social-icon">
        <p>Connect with us on</p>
        <div class="social-icons-list">
          <a
            v-for="social in socialLinks"
            :key="social.alt"
            :href="social.href"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img class="bottom-social-icons" :src="social.src" :alt="social.alt">
          </a>
        </div>
      </div>
      <div class="bottom-separator"></div>
      <div class="bottom-content-navigator">
        <a href="https://www.langhamhospitalitygroup.com/en/" target="_blank" rel="noopener noreferrer">LANGHAM HOSPITALITY GROUP</a>
        <a href="https://www.langhamhospitalitygroup.com/en/media/" target="_blank" rel="noopener noreferrer">MEDIA CENTRE</a>
        <a href="https://www.brilliantbylangham.com/en/faq" target="_self">FAQ</a>
        <a href="https://www.brilliantbylangham.com/en/forms/contact-us" target="_self">CONTACT US</a>
      </div>
      <div class="bottom-separator mobile-alg"></div>
      <div class="footer-content-navigator">
        <a href="https://www.brilliantbylangham.com/en/programme-terms-conditions" target="_self">PROGRAMME TERMS &amp; CONDITIONS</a>
        <a href="https://www.brilliantbylangham.com/en/privacy-policy" target="_self">PRIVACY POLICY</a>
        <a href="https://www.brilliantbylangham.com/en/cookies-policy" target="_self">COOKIES</a>
      </div>
      <br />
      <div class="copyrights-list">
        <p>COPYRIGHT ©BRILLIANT LOYALTY PROGRAM LIMITED</p>
        <p><a href="https://beian.miit.gov.cn/">沪ICP备2024050525</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
import footerBrilliant from '@/components/custom/_langham2026/assets/img/footer_brilliant.png';
import brandLHG from '@/components/custom/_langham2026/assets/img/brand_LHG.png';
import brandCordis from '@/components/custom/_langham2026/assets/img/brand_Cordis.png';
import brandEaton from '@/components/custom/_langham2026/assets/img/Eaton.png';
import brandYing from '@/components/custom/_langham2026/assets/img/Ying\'n_flow_white.png';
import brandChelsea from '@/components/custom/_langham2026/assets/img/brand_Chelsea.png';
import facebookIcon from '@/components/custom/_langham2026/assets/img/facebookIcon.png';
import instagramIcon from '@/components/custom/_langham2026/assets/img/instagramIcon.png';
import wechatIcon from '@/components/custom/_langham2026/assets/img/wechatIcon.png';
import wiboIcon from '@/components/custom/_langham2026/assets/img/wiboIcon.png';

export default {
  name: 'langham-footer',
  data() {
    return {
      assets: { footerBrilliant },
      brandLogos: [
        { src: brandLHG, alt: 'Langham Hospitality Group' },
        { src: brandCordis, alt: 'Cordis' },
        { src: brandEaton, alt: 'Eaton' },
        { src: brandYing, alt: "Ying'n flow" },
        { src: brandChelsea, alt: 'Chelsea' },
      ],
      socialLinks: [
        { href: 'https://www.facebook.com/BrilliantbyLangham', src: facebookIcon, alt: 'Facebook' },
        { href: 'https://www.instagram.com/brilliant.bylangham/', src: instagramIcon, alt: 'Instagram' },
        { href: 'https://www.brilliantbylangham.com/en/brilliant-WeChat-official-account', src: wechatIcon, alt: 'WeChat' },
        { href: 'https://weibo.com/7899027395', src: wiboIcon, alt: 'Weibo' },
      ],
    };
  },
};
</script>
